import { formatDate } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import moment from 'moment';
import { AuthenticationService } from '../../../core/http/authentication.service';
import { DashboardCardComponent } from '../../dashboard/dashboardcard.component';

@Component({
  selector: 'bpw-arp-dashboardcard',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './arp-dashboardcard.component.html',
  styleUrls: ['./arp-dashboardcard.component.scss'],
})
export class ArpDashboardcardComponent implements DashboardCardComponent, OnInit {
  private readonly _authService = inject(AuthenticationService);

  @Input()
  public data: any;
  public visible: boolean;

  readonly hasMiUser = signal(false);
  readonly hasArpUser = signal(false);
  readonly miName = signal('');
  readonly currentDatum = signal('');
  readonly currentJahr = signal(0);

  constructor() {
    this.visible = false;
  }

  ngOnInit(): void {
    this.hasMiUser.set(this._authService.currentUserValue?.hasMiUser ?? false);
    this.hasArpUser.set(this._authService.currentUserValue?.hasArpUser ?? false);
    this.miName.set(this._authService.currentUserValue?.miName ?? '');

    this.currentDatum.set(formatDate(new Date(), 'yyyy-MM-dd', 'en'));
    this.currentJahr.set(moment().year());
  }
}
